import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Reusable sub-tab navigation for consolidated pages.
 * Renders horizontal scrollable pill-style tabs.
 *
 * @param {Array} tabs - Array of { key, label, icon: PhosphorIcon, path }
 * @param {boolean} darkMode
 */
const PageTabs = ({ tabs, darkMode }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Don't render tab bar if there's only one tab
  if (!tabs || tabs.length <= 1) return null;

  const isTabActive = (tab) => location.pathname === tab.path;

  return (
    <div className="mb-4 sm:mb-5">
      <div className="flex gap-1.5 overflow-x-auto no-scrollbar">
        {tabs.map((tab) => {
          const active = isTabActive(tab);
          const Icon = tab.icon;
          return (
            <button
              key={tab.key}
              onClick={() => navigate(tab.path, { replace: true })}
              className={`flex items-center gap-1.5 px-3.5 py-2 rounded-xl text-xs font-bold uppercase tracking-wide whitespace-nowrap transition-all duration-200 shrink-0 ${
                active
                  ? darkMode
                    ? 'bg-primaryB-700 text-primaryA-400'
                    : 'bg-[#373a3f] text-primaryA-400 shadow-card'
                  : darkMode
                    ? 'text-primaryB-400 hover:bg-primaryB-700 hover:text-white'
                    : 'text-primaryB-500 hover:bg-primaryB-100 hover:text-primaryB-900'
              }`}
            >
              {Icon && <Icon weight={active ? 'fill' : 'bold'} className="w-4 h-4" />}
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default PageTabs;
